import React, { useEffect } from "react";
import Nav from "../components/landing/Nav";
import Footer from "../components/landing/Footer";

/**
 * Shared shell for the three legal pages. Keeps typography, colour palette
 * and background identical to the landing so users never feel they've
 * "left the site". The H1 is unique per page.
 */
export default function LegalLayout({ title, updated, children, testid }) {
  useEffect(() => {
    const prev = document.title;
    document.title = `${title} · Mentalidad SIRCS`;
    window.scrollTo(0, 0);
    return () => {
      document.title = prev;
    };
  }, [title]);

  return (
    <div className="min-h-screen bg-bg-base text-ink" data-testid={testid}>
      <Nav />
      <main className="section-light pt-32 md:pt-40 pb-24 md:pb-32">
        <div className="max-w-3xl mx-auto px-6 md:px-8">
          <p className="overline mb-6">◇ Información legal</p>
          <h1 className="font-serif font-normal text-4xl sm:text-5xl lg:text-6xl text-[#0B0E13] leading-[1.05] tracking-[-0.01em]">
            {title}
          </h1>
          <div className="gold-divider mt-8" />
          {updated && (
            <p className="mt-6 text-sm text-[#6E7580] font-sans font-light">
              Última actualización: {updated}
            </p>
          )}
          <article className="legal-prose mt-10 md:mt-12">{children}</article>
        </div>
      </main>
      <Footer />
    </div>
  );
}
